import * as _ from "lodash";
import * as moment from "moment";
import {IComponentOptions, ILogService} from "angular";
import {CourseService} from "../course.service";
import "./course-selector.less";
import {MonashCourse} from "../../model/MonashCourse";
import {TeachingPeriod} from "../../model/TeachingPeriod";
import {Moment} from "moment";
import {IModalInstanceService} from "angular-ui-bootstrap";

interface TeachingPeriodsByFacultyCode {
    [facultyCode: string]: TeachingPeriod[];
}

interface NextClosingDateMessage {
    closeDate: string;
    name: string;
    message: string;
}

class CourseSelectorController {
    public modalInstance: IModalInstanceService;
    public resolve: any;
    public teachingPeriods: TeachingPeriod[];
    public form: ng.IFormController;
    public dismiss: any;
    public close: any;
    private selectedCourse: any;
    private model: any;

    private isLoading: boolean;
    private years: any[];
    private courseYear: any;
    private blockedCourse: boolean;
    private existingCourse: boolean;
    private currentCourses: any[];
    private applyingNewCourse: boolean;
    private original: any;

    private teachingPeriodsByFacultyCode: TeachingPeriodsByFacultyCode;
    private emptyClosingDateMessage = {
        closeDate: "",
        message: "",
        name: ""
    };
    private applyingCourse: MonashCourse;


    /* @ngInject */
    constructor(private $log: ILogService,
                private courseService: CourseService) {
    }

    public $onInit() {

        this.$log.debug("resolve is %o", this.resolve);
        this.model = {};
        this.model.course  = this.resolve.courseApplied;
        this.currentCourses = this.resolve.currentCourses;
        this.teachingPeriods = this.resolve.teachingPeriods;

        this.years = this.populateYears();
        this.courseYear = this.years[1];
        if (this.model.course) {

            if (this.model.course.campus === undefined || this.model.course.campus === null) {
                if (this.model.course.campuses !== null && this.model.course.campuses.length === 1) {
                    this.model.course.campus = this.model.course.campuses[0].description;
                }
            }


            if (this.model.course.fromCourseAttempt === undefined) {
                this.model.course.fromCourseAttempt = this.model.course.academicYear === undefined;
            }
            this.applyingNewCourse = !this.model.course.fromCourseAttempt;
            // if (!this.applyingNewCourse) {
            //     this.$log.debug("Not applying for new course, so the model course will be put at the first of current course list.");
            //     this.currentCourses = [this.model.course].concat(this.currentCourses.filter((course) => course.code !== this.model.course.code));
            // }
            this.selectedCourse = this.model.course;

            if (this.selectedCourse.campuses.length === 1) {
                this.model.campus = this.selectedCourse.campuses[0].code;
            }

            if (this.model.course.academicYear) {
                this.courseYear = this.model.course.academicYear;
            }

            this.$log.debug("init selected course");
        }

        if (this.teachingPeriods) {
            this.teachingPeriodsByFacultyCode = _.groupBy(this.teachingPeriods, "facultyCode");
        }

        this.original = _.cloneDeep(this.model);
    }

    public addCourse() {
        if (this.form.$valid) {

            this.close({$value: this.model});
        }
    }

    public searchCourses(query, year): any {
        return this.courseService.getRemoteCourses(query, year);
    }

    public onSelectedCourse($item, $model, $label, $event) {
        this.$log.debug("selected $item: %o, $model: %o, $label: %o, $event: %o", $item, $model, $label, $event);
        this.model.campus = ($item.campuses.length === 1) ? $item.campuses[0].code : null;
        this.model.courseCode = $item.code;
        this.model.courseName = $item.title;
        this.model.code = $item.code;
        this.model.title = $item.title;
        this.model.facultyCode = $item.facultyCode;
        this.model.facultyName = $item.faculty;
        this.selectedCourse = $item;
        this.checkCourse();
    }

    public clearSelectedCourse() {
        this.selectedCourse = null;
        this.model = null;
    }

    public onCourseChange(course) {
        this.$log.debug("the course is %o", course);
    }

    private cancel() {
        this.dismiss({$value: "cancel"});
    }

    private toMoment(str: string) {
        // return moment(str, "Jun 20, 2019 12:00:00 AM");
        return moment(str, "MMM DD YYYY h:mm:ss a");
    }

    private calculateClosingDate(teachingPeriod: TeachingPeriod): Moment {
        const closeDate = teachingPeriod.closingDate ?
            this.toMoment(teachingPeriod.closingDate) :
            this.toMoment(teachingPeriod.startDate).subtract(1, "weeks"); // According to spec: https://trello.com/c/ULLxCin1/34-add-application-close-date-offer-lapse-date
        return closeDate;
    }

    private toClosingDateMessage(teachingPeriod: TeachingPeriod | undefined, fallbackInfo: NextClosingDateMessage | null): NextClosingDateMessage | undefined {
        if (!teachingPeriod) {
            return undefined;
        }
        const closeDate = this.calculateClosingDate(teachingPeriod).format("DD/MM/YYYY");

        return {
            closeDate: closeDate ? closeDate : fallbackInfo ? fallbackInfo.closeDate : "",
            name: teachingPeriod.description ? teachingPeriod.description : fallbackInfo ? fallbackInfo.name : "",
            message: teachingPeriod.studentsMessage ? teachingPeriod.studentsMessage : fallbackInfo ? fallbackInfo.message : ""
        };
    }

    private getFallbackClosingDateMessage(): NextClosingDateMessage {
        const fallbackTeachingPeriods = this.teachingPeriodsByFacultyCode[""];
        if (fallbackTeachingPeriods.length === 0) {
            this.$log.error("There are no fallback teaching periods specified. No message will be shown!");
            return this.emptyClosingDateMessage;
        }

        return this.getDefaultClosingDateMessage(fallbackTeachingPeriods, null);

    }

    private getDefaultClosingDateMessage(teachingPeriods: TeachingPeriod[], fallbackInfo: NextClosingDateMessage | null): NextClosingDateMessage {
        const fallbackForFaculty = teachingPeriods
            .filter((tp) => !tp.courseCodes || tp.courseCodes.filter((code) => code !== "").length === 0);

        if (fallbackForFaculty.length === 0) {
            return fallbackInfo;
        }

        return this.toClosingDateMessage(this.findNextTeachingPeriod(fallbackForFaculty), fallbackInfo);
    }

    private findTeachingPeriodsPerCourse(teachingPeriodsForFaculty: TeachingPeriod[], courseCode: string | undefined): TeachingPeriod[] {
        return teachingPeriodsForFaculty
            .filter((teachingPeriod) =>
                teachingPeriod.courseCodes && teachingPeriod.courseCodes.indexOf(courseCode) >= 0);
    }

    private findNextTeachingPeriod(teachingPeriods: TeachingPeriod[]): TeachingPeriod | undefined {
        const today = moment();
        const validTeachingPeriods = teachingPeriods
            .filter((tp) => today.isBefore(this.calculateClosingDate(tp))) // Remove previous closing dates;
            .sort((a, b) => this.calculateClosingDate(a).diff(this.calculateClosingDate(b))); // sort closest to most far

        if (validTeachingPeriods.length > 0) {
            return validTeachingPeriods[0];
        }

        return undefined;
    }

    // https://trello.com/c/ULLxCin1/34-add-application-close-date-offer-lapse-date
    private getClosingDateMessage() {

        const fallbackMessage = this.getFallbackClosingDateMessage();

        if (this.model) {
            const facultyCode = this.model.facultyCode;
            const courseCode = this.model.courseCode;
            const teachingPeriodsForFaculty = this.teachingPeriodsByFacultyCode[facultyCode];

            // If there are no teaching periods specified for the faculty, return the fallback message.
            if (!teachingPeriodsForFaculty || teachingPeriodsForFaculty.length === 0) {
                return fallbackMessage;
            }

            const defaultFacultyMessage = this.getDefaultClosingDateMessage(teachingPeriodsForFaculty, fallbackMessage);

            // Find the teaching period for the course.
            const teachingPeriodsPerCourse = this.findTeachingPeriodsPerCourse(teachingPeriodsForFaculty, courseCode);

            // If there are no TP defined, fallback to the faculty one.
            if (teachingPeriodsPerCourse.length === 0) {
                return defaultFacultyMessage;
            }

            return this.toClosingDateMessage(this.findNextTeachingPeriod(teachingPeriodsPerCourse), defaultFacultyMessage);
        }

        return this.emptyClosingDateMessage;
    }



    private populateYears(): any[] {
        const years = [];
        const year = moment().year();
        _.times(3, (i) => {
            years.push(year + i);
        });
        return years;
    }

    private checkCourse() {
        this.existingCourse = !this.checkExistingCourse();
        this.checkBlockedCourse().then((blocked) => {
            this.blockedCourse = blocked;
        });
    }



    private checkBlockedCourse() {
        return this.courseService.getBlockedCourses(this.model.courseCode).then((blocked) => {
            return (blocked && blocked.length > 0);
        });
    }

    private checkExistingCourse() {
        const containsCourse = this.currentCourses.some((course) => {
            return this.model.courseCode === course.code;
        });

        return !containsCourse;
    }

    private revert() {
        this.model = _.cloneDeep(this.original);
    }


    private isNullOrUndefined(object: any) {
        if (object !== undefined && object !== null) {
            return false;
        } else {
            return true;
        }

    }
}

export const CourseSelectorComponent: IComponentOptions = {
    bindings: {
        close: "&",
        dismiss: "&",
        resolve: "="
    },
    controller: CourseSelectorController,
    template: require("./course-selector.html")
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/course/selector/course-selector.component.ts